var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contert"},[_c('el-input',{attrs:{"placeholder":"语音内容"},model:{value:(_vm.voiceTxt),callback:function ($$v) {_vm.voiceTxt=$$v},expression:"voiceTxt"}}),_c('button',{on:{"click":_vm.play}},[_vm._v(" 开始合成 ")]),_c('button',{on:{"click":_vm.pause}},[_vm._v(" 停止播放 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }